import React, {useContext} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton} from '@mui/material';
import {ArchiveOutlined} from '@mui/icons-material';
import {ApplicationContext} from '../../context/ApplicationContext';
import {submitArchiveSource} from '../../services/source.service';
import _ from 'lodash';
import {useHistory} from "react-router-dom";

const ArchiveSourceDialog = (props) => {
    const AppContext = useContext(ApplicationContext);
    const [open, setOpen] = React.useState(false);

    const history = useHistory();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const submitForm = () => {
        submitArchiveSource({
            source_key: props.sourceKey, is_archived: true
        })
            .then((reply) => {
                AppContext.handleNotification('Source archived successfully.');
                handleClose();
                history.goBack();
            })
            .catch((err) => {
                const isNotZero = _.find(err.graphQLErrors, {message: "Source is not at a balance of zero."});
                isNotZero ? AppContext.handleError('Source balance must be zero before it can be archived.') : AppContext.handleError('Unable to archive source.');
            })
    }

    return (<div>
        <IconButton
            onClick={handleClickOpen}
            style={{backgroundColor: 'rgba(99, 102, 241, 0.1)', color: '#6366f1', float: 'right', padding: '12px', marginLeft: '1rem'}}
        >
            <ArchiveOutlined/>
        </IconButton>
        <Dialog open={open} onClose={handleClose} PaperProps={{ className: 'modal' }}>
            <DialogTitle className='primary-font'>Archive Source</DialogTitle>
            <DialogContent className='primary-font'>
                <DialogContentText className='primary-font'>
                    Archiving a source will remove it from view, but its entries will remain in order to calculate
                    historical wealth.
                    A source's current balance must be equal to zero before it can be archived.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className='modal-action-cancel' variant="text" onClick={handleClose}>Cancel</Button>
                <Button className='modal-action-submit' variant="contained" onClick={submitForm}>Proceed</Button>
            </DialogActions>
        </Dialog>
    </div>);
}

export default ArchiveSourceDialog;
